import "@styles/map.scss";
import L from 'leaflet';

(() => {

  let $map = document.querySelector('.js-map');
  let map = L.map($map, {
    zoomControl: false
  });
  map.scrollWheelZoom.disable();

  let mapArray = [];
  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png?key=cb1_4514_1_bdd6e8a59813a5e729e6274d', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
  }).addTo(map);

  L.control.zoom({
    position: 'topright'
  }).addTo(map);

  const dataItems = document.querySelectorAll('[data-gps]');
  dataItems.forEach((dataItem) => {
    let coord = dataItem.getAttribute('data-gps').replace(',', '').split(' ');
    let name = dataItem.textContent;
    let affiliate = dataItem.getAttribute('data-affiliate');
    let link = dataItem.getAttribute('data-link');
    let svg = '';
    let marker;
    switch (affiliate) {
      case '1':
        svg = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 42 42" xml:space="preserve" enable-background="new 0 0 42 42"><circle cx="21" cy="-267" r="21" fill="#fff" transform="translate(415 507) translate(-415 -219)"/><path d="M-392.8-504.8v3.4a9 9 0 0 1-4.2 1.1h-1l-2.9.4-1.5.4-1.1.4-2.3-1.4-1.8-.8-.8-.3c-.8-.3-1.5-.5-2.3-.6l-.6-.1-2-.2h-1.5v-2.2c0-1.2 1-2.2 2.2-2.2h17.7c1.1-.1 2.1.9 2.1 2.1z" fill="#293051" transform="translate(415 507) translate(9.9 9.9)"/><path d="m-397.1-493.7 1.4-.1 2.3-.4.5-.1v-4.7c-1 .4-2.1.7-3.2.8h-1l-1.8.1a20 20 0 0 0-3.7.9l-1.3.5-2.1-1.4-2.3-1.1-.8-.3-1.8-.5-1.4-.3-1.5-.1h-1.2v4.4h.2c.9 0 1.8.1 2.6.3l2.4.7c.7.3 1.4.6 2.1 1.1l1.8 1.4a15.3 15.3 0 0 1 2.6 3.2H-415v2.2c0 1.2 1 2.2 2.2 2.2h17.7c1.2 0 2.2-1 2.2-2.2v-2.2h-5.5l-.9-1.9-.3-.5-1-1.5c.8-.3 1.6-.4 2.4-.5h1.1z" fill="#fcc00d" transform="translate(415 507) translate(9.9 9.9)"/></svg>';
        marker = L.marker(coord, {
          icon: L.divIcon(
            {
              html: svg,
              iconSize: [42, 42],
              iconAnchor: [21, 42],
            }), interactive: true
        });
        break;
      default:
        svg = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 28 28" xml:space="preserve" enable-background="new 0 0 28 28"><circle cx="14" cy="-274" r="14" fill="#fcc00d" transform="translate(336 392) translate(-336 -104)"/><path d="M-316.4-377.2h-.4l-1.6 1.2-.2.4c0 .2.1.3.3.4l.3.1a4.5 4.5 0 0 1-2.6 2.3c-.2.1-.4 0-.5-.1-.2-.1-.2-.3-.3-.5v-4.5h1.7c.4 0 .7-.3.8-.6l-.2-.5a.8.8 0 0 0-.5-.2h-1.8v-1.4a2.2 2.2 0 0 0 1.4-2.8 2.1 2.1 0 0 0-2-1.5c-.6 0-1.1.2-1.6.6-.4.4-.7 1-.7 1.6 0 .9.6 1.8 1.5 2.1v1.4h-1.7c-.4-.1-.7.2-.8.5s.2.7.5.8h2v4.5c0 .2-.1.4-.3.5l-.5.1a4.5 4.5 0 0 1-2.6-2.3l.3-.1.3-.3c0-.2 0-.3-.2-.4l-1.6-1.2a.3.3 0 0 0-.4 0l-.3.3-.3 1.8c0 .2 0 .3.2.4l.5.1.3-.1c1.4 2.9 4.9 4.2 7.8 2.9a5.8 5.8 0 0 0 2.9-2.9l.3.1c.2.1.5 0 .6-.2v-.3l-.4-1.9c.1-.1 0-.2-.2-.3zm-5.6-4.7c-.4 0-.8-.4-.8-.8s.4-.8.8-.8.8.4.8.8-.3.7-.8.8c.1 0 0 0 0 0z" fill="#293051" stroke="#293051" stroke-width=".3" transform="translate(336 392)"/></svg>';
        marker = L.marker(coord, {
          icon: L.divIcon(
            {
              html: svg,
              iconSize: [28, 28],
              iconAnchor: [14, 28],
            }), interactive: true
        });
    }
    marker.bindPopup('<a href="' + link + '">' + name + '</a>', { offset: [0, -25] });

    marker.on('click', (e) => {
      map.setView(e.target.getLatLng(), 17)
    })

    mapArray.push(marker);
  });

  let groupMapArray = L.featureGroup(mapArray).addTo(map);
  map.fitBounds(groupMapArray.getBounds(), { padding: [10, 10], maxZoom: 10 });
})();